exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "grouping-selector ::ng-deep .grouping-box {\n  margin-left: 32px;\n}\n\n.osr-legend {\n  flex-grow: 1;\n  justify-content: flex-end;\n  display: flex;\n}\n\n.grid-toolbar-content {\n  display: flex;\n  flex-grow: 1;\n}\n\n", ""]);

// exports
